var styleDataHash = "0e107a80";
const injectCss = (() => {
  var css = `.s-O6r{--shimmer-base-color:#f5f5f5;background-color:var(--shimmer-base-color);pointer-events:none;z-index:1}.eOtQK,.s-O6r{inset:0;position:absolute}.eOtQK{overflow:hidden}.eOtQK:after{animation:sDYLE 1s linear infinite;background:linear-gradient(90deg,transparent,hsla(0,0%,100%,.3),transparent 50%);bottom:0;content:"";left:0;position:absolute;right:0;top:0;transform:translateX(-100%)}@keyframes sDYLE{to{transform:translateX(100%)}}.JBaMk{bottom:12px;left:50%;position:absolute;transform:translateX(-50%);z-index:2}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var layout_background_loader_default = {
  "overlay": "s-O6r",
  "shimmer": "eOtQK",
  "layout-shimmer": "sDYLE",
  "label": "JBaMk"
};
export {
  layout_background_loader_default as default,
  injectCss
};
//# sourceMappingURL=layout-background-loader-scss.js.map
